import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 213.98 210.2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M211.43,210.2H2.55c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h208.88c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M189.72,191.55H24.26c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h165.46c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M119.7,173.51h-25.43c-1.41,0-2.55-1.14-2.55-2.55v-99.35c0-1.41,1.14-2.55,2.55-2.55h25.43c1.41,0,2.55,1.14,2.55,2.55v99.35c0,1.41-1.14,2.55-2.55,2.55ZM96.82,168.41h20.33v-94.25h-20.33v94.25Z" />
        <path d="M65.89,173.51h-25.43c-1.41,0-2.55-1.14-2.55-2.55v-99.35c0-1.41,1.14-2.55,2.55-2.55h25.43c1.41,0,2.55,1.14,2.55,2.55v99.35c0,1.41-1.14,2.55-2.55,2.55ZM43.01,168.41h20.33v-94.25h-20.33v94.25Z" />
        <path d="M173.51,173.51h-25.43c-1.41,0-2.55-1.14-2.55-2.55v-99.35c0-1.41,1.14-2.55,2.55-2.55h25.43c1.41,0,2.55,1.14,2.55,2.55v99.35c0,1.41-1.14,2.55-2.55,2.55ZM150.63,168.41h20.33v-94.25h-20.33v94.25Z" />
        <path d="M117.87,40.84h-21.77c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h21.77c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M198.91,56.12H11.15c-5.5,0-9.97-4.47-9.97-9.97,0-4.19,2.65-7.96,6.59-9.38L104.12.17c.58-.22,1.23-.22,1.81,0l96.4,36.62c3.9,1.41,6.55,5.17,6.55,9.36,0,5.5-4.47,9.97-9.97,9.97ZM105.03,5.28L9.54,41.56c-1.96.71-3.26,2.55-3.26,4.6,0,2.68,2.18,4.87,4.87,4.87h187.75c2.69,0,4.87-2.18,4.87-4.87,0-2.05-1.29-3.89-3.22-4.58L105.03,5.28Z" />
      </g>
    </svg>
  )
}

export default Icon
